import React from "react";
import { MultiPurposeParagraph } from "@/atoms/Paragraph";
import { FullBackgroundImage } from "@/components/Molecules/ImageCard";
import { VideoCard } from "@/components/Molecules/VideoCard";
import { OverlayShadow } from "@/components/Molecules/OverlayShadow/Overlay";
import { MultiPurposeTitle, Title } from "@/components/Atoms/Title";
import { useState, Fragment } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { ClosePop, PlayIcon } from "@/components/Atoms/Vectors";
import Image from "@/components/Atoms/Image";
import { ButtonMaster } from "@/components/Atoms/Buttons";

const defaultShadowOverlayColor = { hex: "#000" } as const;

export default function VideoGallery(data: any) {
  let [isOpen, setIsOpen] = useState(9999999);
  const [playing, setPlaying] = useState(false);
  const [visibleItems, setVisibleItems] = useState(5);
  const shadowOverlayColor =
    data.shadowOverlayBaseColor ?? defaultShadowOverlayColor;

  function closeModal() {
    setIsOpen(9999999);
  }

  function showModal(i: number) {
    setIsOpen(i);
  }

  function loadMore() {
    setVisibleItems((prev) => {
      const newCount = prev + 5;

      return newCount;
    });
  }

  const videosToShow = data.addLoadMoreButton
    ? data.videoGallery?.slice(0, visibleItems)
    : data.videoGallery;

  const hasMoreVideos =
    data.addLoadMoreButton && data.videoGallery?.length > visibleItems;

  return (
    <>
      <div
        style={{ backgroundColor: data?.bgColor?.color?.hex }}
        className={` ${
          data.useSectionMargins
            ? "py-6 md:pb-6 md:pt-24 lg:pt-32 lg:pb-12"
            : "py-0 pb-12"
        }  relative w-full`}
      >
        <div className="container mx-auto 2xl:max-w-[1360px]">
        {data.addTitle && (
          <div className="text-center mb-12">
            <MultiPurposeTitle
              type="default"
              tag="h3"
              data={data.title}
              color={data.textColor?.color}
              columns={"single"}
            />
          </div>
        )}
        <div className="grid grid-cols-4 gap-6">
          {videosToShow?.map((galleryConf: any, i: number) => {
            const isPlaceholderCard = galleryConf?.replaceVideoWithPlaceholder;

            return (
              <div
                className={`${
                  i == 0 ? "col-span-4" : "col-span-2 lg:col-span-1"
                } bg-slate-200 h-[320px] lg:h-[435px]  relative group overflow-hidden`}
                key={i}
              >
                {isPlaceholderCard ? (
                  <>
                    {data.cardType == "bottom" ? (
                      <article
                        className={` flex items-start justify-end flex-col relative z-10  p-4 lg:p-8 h-full text-left max-w-lg`}
                      >
                        <MultiPurposeTitle
                          tag="p"
                          type={i == 0 ? "featured" : "default"}
                          data={galleryConf?.title}
                          color={data.titleColor?.color}
                        />
                        <MultiPurposeParagraph
                          type={i == 0 ? "headline" : "label"}
                          data={galleryConf?.description}
                          color={data.textColor?.color}
                        />
                        {galleryConf?.placeholderText && (
                          <MultiPurposeParagraph
                            type={i == 0 ? "default" : "label"}
                            data={galleryConf?.placeholderText}
                            color={data.titleColor?.color}
                          />
                        )}
                      </article>
                    ) : (
                      <article
                        className={` flex items-start justify-start flex-col relative z-10  p-4 lg:p-8 h-full text-left`}
                      >
                        <MultiPurposeParagraph
                          type={i == 0 ? "headline" : "default"}
                          data={galleryConf?.title}
                          color={data.titleColor?.color}
                        />
                        <MultiPurposeParagraph
                          type={i == 0 ? "default" : "label"}
                          data={galleryConf?.description}
                          color={data.textColor?.color}
                        />
                        {galleryConf?.placeholderText && (
                          <MultiPurposeParagraph
                            type={i == 0 ? "default" : "label"}
                            data={galleryConf?.placeholderText}
                            color={data.textColor?.color}
                          />
                        )}
                      </article>
                    )}

                    {data.cardType == "bottom" ? (
                      <OverlayShadow
                        data={data.shadowOverlay}
                        layout={i == 0 ? "left" : "bottom"}
                        color={shadowOverlayColor}
                        format={data.textAlignment}
                      />
                    ) : (
                      <OverlayShadow
                        data={data.shadowOverlay}
                        layout={"left"}
                        color={shadowOverlayColor}
                        format={data.textAlignment}
                      />
                    )}

                    <div className="group-hover:scale-[1.1] absolute top-0 left-0 w-full h-[435px] transition-all duration-1000">
                      <FullBackgroundImage
                        data={
                          galleryConf?.placeholder ||
                          galleryConf?.video?.video?.thumbnailUrl
                        }
                      />
                    </div>
                  </>
                ) : (
                  <>
                    <button
                      className="w-full h-full"
                      type="button"
                      onClick={() => showModal(i)}
                    >
                      {data.cardType == "bottom" ? (
                        <>
                          {" "}
                          <article
                            className={` flex items-start justify-end flex-col relative z-10  p-4 lg:p-8 h-full text-left `}
                          >
                            {" "}
                            <MultiPurposeParagraph
                              type={i == 0 ? "headline" : "default"}
                              data={galleryConf?.title}
                              color={data.titleColor?.color}
                            />
                            <div className="max-w-[90%]">
                              <MultiPurposeParagraph
                                type={i == 0 ? "default" : "label"}
                                data={galleryConf?.description}
                                color={data.textColor?.color}
                              />
                            </div>
                            <div className="w-full mt-2 flex justify-end lg:absolute right-8 bottom-8">
                              {data.customPlayIcon ? (
                                <div
                                  className={`${
                                    i == 0 ? "w-12 h-12" : "w-8 h-8"
                                  }  flex items-center justify-center`}
                                >
                                  <Image
                                    data={data.customPlayIcon.img}
                                    className="w-full h-full object-contain"
                                  />
                                </div>
                              ) : (
                                <PlayIcon color={data.textColor?.color?.hex} />
                              )}
                            </div>
                          </article>
                        </>
                      ) : (
                        <article
                          className={` flex items-start justify-start flex-col relative z-10  p-4 lg:p-8 h-full text-left`}
                        >
                          {" "}
                          <MultiPurposeParagraph
                            type={i == 0 ? "headline" : "default"}
                            data={galleryConf?.title}
                            color={data.titleColor?.color}
                          />
                          <div className="w-full mt-2 flex justify-end lg:absolute right-8 bottom-8">
                            {data.customPlayIcon ? (
                              <div
                                className={`${
                                  i == 0 ? "w-12 h-12" : "w-8 h-8"
                                }  flex items-center justify-center`}
                              >
                                <Image
                                  data={data.customPlayIcon.img}
                                  className="w-full h-full object-contain"
                                />
                              </div>
                            ) : (
                              <PlayIcon color={data.textColor?.color?.hex} />
                            )}
                          </div>
                        </article>
                      )}
                    </button>

                    {data.cardType == "bottom" ? (
                      <OverlayShadow
                        data={data.shadowOverlay}
                        layout={i == 0 ? "left" : "bottom"}
                        color={shadowOverlayColor}
                        format={data.textAlignment}
                      />
                    ) : (
                      <OverlayShadow
                        data={data.shadowOverlay}
                        layout={"left"}
                        color={shadowOverlayColor}
                        format={data.textAlignment}
                      />
                    )}

                    <div className="group-hover:scale-[1.1] absolute top-0 left-0 w-full h-[435px] transition-all duration-1000">
                      <FullBackgroundImage
                        data={
                          galleryConf?.placeholder ||
                          galleryConf?.video?.video?.thumbnailUrl
                        }
                      />
                    </div>
                    <Transition appear show={isOpen == i} as={Fragment}>
                      <Dialog
                        as="div"
                        className="relative z-[9999999]"
                        onClose={closeModal}
                      >
                        <Transition.Child
                          as={Fragment}
                          enter="ease-out duration-300"
                          enterFrom="opacity-0"
                          enterTo="opacity-100"
                          leave="ease-in duration-200"
                          leaveFrom="opacity-100"
                          leaveTo="opacity-0"
                        >
                          <div className="fixed inset-0 bg-black bg-opacity-75" />
                        </Transition.Child>

                        <div className="fixed inset-0 overflow-y-auto">
                          <div className="flex min-h-full items-center justify-center p-4 text-center">
                            <Transition.Child
                              as={Fragment}
                              enter="ease-out duration-300"
                              enterFrom="opacity-0 scale-95"
                              enterTo="opacity-100 scale-100"
                              leave="ease-in duration-200"
                              leaveFrom="opacity-100 scale-100"
                              leaveTo="opacity-0 scale-95"
                            >
                              <Dialog.Panel className="w-[95vw] h-[95vh] max-w-[1200px]  transform overflow-hidden  text-left align-middle shadow-xl transition-all">
                                <div className="w-full max-h-[75%] bg-black m-auto relative">
                                  <VideoCard
                                    file={galleryConf?.video?.video}
                                    controls={[
                                      false,  // loop
                                      false,  // muted
                                      true,   // controls
                                      0,      // videoPreview time
                                      true,   // autoplay
                                    ]}
                                    color={data.textColor?.color?.hex}
                                    className="w-full h-full"
                                    onClick={() => setPlaying(false)}
                                    placement="VideoGallery"
                                    poster={galleryConf?.placeholder}
                                    bgColor={{ hex: "#000000" }}
                                    customIcon={data.customPlayIcon ? [true, data.customPlayIcon] : undefined}
                                  />
                                </div>
                                <article
                                  style={{
                                    backgroundColor:
                                      data?.popupBgColor?.color?.hex,
                                  }}
                                  className="p-6 lg:p-12 flex flex-col"
                                >
                                  <div className="col-span-1">
                                    <MultiPurposeTitle
                                      tag="p"
                                      type="featured"
                                      data={galleryConf?.title}
                                      color={data.popupTitleColor?.color}
                                    />
                                  </div>
                                  <div className="col-span-2">
                                    <MultiPurposeParagraph
                                      type="default"
                                      data={galleryConf?.description}
                                      color={data.popupTextColor?.color}
                                    />
                                  </div>

                                  <div className="absolute top-4 right-4">
                                    <button type="button" onClick={closeModal}>
                                      <ClosePop
                                        color={data.textColor?.color?.hex}
                                      />
                                    </button>
                                  </div>
                                </article>
                              </Dialog.Panel>
                            </Transition.Child>
                          </div>
                        </div>
                      </Dialog>
                    </Transition>
                  </>
                )}
              </div>
            );
          })}
        </div>

        {hasMoreVideos && data.loadMoreButton && (
          <div className="flex justify-center my-6 lg:mt-12">
            <ButtonMaster
              onClick={loadMore}
              anim="slideLeft"
              type={data.loadMoreButton.buttonStyle}
              cta={data.loadMoreButton.typeColor?.color}
              color={data.loadMoreButton.labelColor?.color}
              customIcon={data.loadMoreButton.icon?.img}
              customColor={data.loadMoreButton.iconColor?.color}
              target=""
            >
              {data.loadMoreButton.buttonLabel?.label || "Load More"}
            </ButtonMaster>
          </div>
        )}
        </div>
      </div>
    </>
  );
}

export const fragment = `
    fragment SectionGalleryVideoFragment on SectionGalleryVideoRecord {
        __typename
      id
      name
      layout 
      useSectionMargins
          addTitle
    title
    titleColor {
      color {
        hex
      }
    }
    cardType
    customPlayIcon {
               img {
            alt
            url
            width
            height
          }
    }
    addLoadMoreButton
    loadMoreButton {

       ...pageRelatedFragment
 
    }
      bgColor{
        color{
          hex
        }
      }
        textColor{
          color{
            hex
          }
        }
        popupBgColor {
          color {
            hex
          }
        }
        popupTitleColor {
          color {
            hex
          }
        }
        popupTextColor {
          color {
            hex
          }
        }
        shadowOverlay
        shadowOverlayBaseColor {
          hex
        }
        textAlignment
      videoGallery {
        __typename
        title
        description
        replaceVideoWithPlaceholder
        placeholderText
        usePlaceholder
        placeholder {
          smartTags
          responsiveImage {
            ...responsiveImageFragment
          }
        }
        video {
          id
          video {
            mp4Url
            mp4High: mp4Url(res: high)
            mp4Med: mp4Url(res: medium)
            mp4Low: mp4Url(res: low)
            thumbnailUrl
            thumbJpg: thumbnailUrl(format: jpg)
            streamingUrl
            muxAssetId
            muxPlaybackId
          }
        }
      }
    }
`;
